import React, { useState } from 'react';
// import './ExpenseEntryPage.css';

function ExpenseEntryPage() {
  // State for form fields
  const [gstApplied, setGstApplied] = useState(false);
  const [expenseCategory, setExpenseCategory] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [note, setNote] = useState('');

  // Auto-generated expense number
  const expenseNumber = "EXP-" + Date.now();

  const handleClearCategory = () => {
    setExpenseCategory('');
  };

  return (
    <div className="crm-expense-entry-page">
      <ExpenseSidebar />

      <div className="crm-expense-entry-content">
        <ExpenseHeader />

        <div className="crm-expense-entry-form-container">
          {/* Box 1 */}
          <div className="crm-expense-entry-form-box">
            <div className="crm-field-group">
              <label>Expense with GST</label>
              <div className="crm-gst-field">
                <input 
                  type="checkbox" 
                  checked={gstApplied} 
                  onChange={(e) => setGstApplied(e.target.checked)} 
                />
                <span className="crm-gst-toggle">{gstApplied ? "OK" : "OFF"}</span>
              </div>
            </div>
            <div className="crm-field-group">
              <label>Expense Category</label>
              <div className="crm-dropdown-clear-container">
                <select 
                  value={expenseCategory} 
                  onChange={(e) => setExpenseCategory(e.target.value)}
                >
                  <option value="">Select Category</option>
                  <option value="bankFee">Bank Fee and Charges</option>
                  <option value="salaries">Employees Salaries and Advances</option>
                  <option value="printing">Printing and Stationary</option>
                  <option value="rawMaterial">Raw Material</option>
                  <option value="rent">Rent Expenses</option>
                  <option value="repair">Repair and Maintenance</option>
                  <option value="telephone">Telephone and Internet Expense</option>
                  <option value="transport">Transportation and Travel Expenses</option>
                </select>
                {expenseCategory && (
                  <span className="crm-clear-btn" onClick={handleClearCategory}>X</span>
                )}
              </div>
              <div className="crm-add-category">
                <span className="crm-add-category-link">+ Add Category</span>
              </div>
              <div className="crm-auto-generated">
                <label>Expense Number:</label>
                <span>{expenseNumber}</span>
              </div>
            </div>
          </div>

          {/* Box 2 */}
          <div className="crm-expense-entry-form-box">
            <div className="crm-field-group">
              <label>Original Invoice Number</label>
              <input 
                type="text" 
                value={invoiceNumber} 
                onChange={(e) => setInvoiceNumber(e.target.value)}
                placeholder="Enter invoice number"
              />
            </div>
            <div className="crm-field-group">
              <label>Date</label>
              <input 
                type="date" 
                value={invoiceDate} 
                onChange={(e) => setInvoiceDate(e.target.value)}
              />
            </div>
            <div className="crm-field-group">
              <label>Payment Mode</label>
              <select 
                value={paymentMode} 
                onChange={(e) => setPaymentMode(e.target.value)}
              >
                <option value="">Select Payment Mode</option>
                <option value="cash">Cash</option>
                <option value="bank">Bank</option>
                <option value="credit">Credit</option>
              </select>
            </div>
            <div className="crm-field-group">
              <label>Note</label>
              <textarea 
                value={note} 
                onChange={(e) => setNote(e.target.value)}
                placeholder="Enter note"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Sidebar Component with Unique CSS
function ExpenseSidebar() {
  return (
    <div className="crm-expense-sidebar">
      <h3 className="crm-sidebar-title">Accounting Solutions</h3>
      <ul className="crm-sidebar-list">
        <li className="crm-sidebar-item">Cash and Bank</li>
        <li className="crm-sidebar-item">E-Invoicing</li>
        <li className="crm-sidebar-item">Automated Bills</li>
        <li className="crm-sidebar-item crm-sidebar-active">Expenses</li>
      </ul>
    </div>
  );
}

// Header Component with Unique CSS for Header & Header Links
function ExpenseHeader() {
  return (
    <div className="crm-expense-entry-header">
      <div className="crm-header-left">
        <button className="crm-back-btn">{'<-'}</button>
        <h2 className="crm-expense-entry-title">Create Expense</h2>
      </div>
      <div className="crm-header-right">
        <button className="crm-settings-btn">⚙</button>
        <button className="crm-cancel-btn">Cancel</button>
        <button className="crm-save-btn">Save</button>
      </div>
    </div>
  );
}

export default ExpenseEntryPage;
